// @flow

import * as React from 'react';
import type { Node } from 'react';
import { useEffect, useState } from 'react';

import './style.scss';

import Title from 'components/Title';
import Button from 'components/Button';

type Props = {
  url: string,
};

export default function RepositoryInfo(props: Props): Node {
  const { url } = props;
  const [repoData, setRepoData] = useState(null);

  useEffect(() => {
    setRepoData({
      name: url.replace('https://api.github.com/repos/', ''),
      url: url.replace('https://api.github.com/repos/', 'https://github.com/'),
    });
  }, [url]);

  return (
    <div className="RepositoryInfo">
      {repoData && (
        <>
          <Title tag="span" fontSize="s">
            {repoData.name}
          </Title>
          <Button
            isRounded
            secondary
            iconFill="primary"
            isTargetBlank
            href={repoData.url}
            onClick={() => {
              if (process.env.NODE_ENV === 'production')
                window.analytics.track('Go to repo clicked');
            }}
          >
            Go to repo
          </Button>
        </>
      )}
    </div>
  );
}
